module.exports = __webpack_public_path__ + "4690688a4e286d046d22a9b38caad942.png";